/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-18 13:43:08
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Pilih model perangkat",
    name2: "Keterangan Kerusakan:",
    name3: "Ketuk untuk memilih toko layanan",
    name4: "Toko Layanan:",
    name5: "Waktu Pemesanan:",
    name6: "Harap jelaskan masalah perangkat Anda secara terperinci!",
    name7: "Ketuk untuk memilih waktu kedatangan",
    name8: "Masukkan perincian kontak yang benar agar kami dapat menghubungi Anda",
    name9: "Waktu reservasi yang tersedia adalah sebagai berikut",
    name10: "Masukkan nomor telepon Anda",
    name11: "Harga",
    name12: "Informasi Pribadi:",
    name13: "Silahkan masukkan nama anda",
    name14: "Kirim",
    name15: "Batal",
    name16: "Oke",
  },
  shops: {
    name1: "Berdasarkan merek yang Anda pilih, toko-toko berikut dapat melayani Anda!",
    name2: "Segera hadir di lebih banyak toko ritel! Tetaplah bersama kami!",
  },
  price: {
    name1: "Merek",
    name2: "Model",
    name3: "ITEM",
    name4: "Harga",
    name5: "Pengingat Ramah:",
    name6: "Harga ini hanya untuk referensi, dan harga sesungguhnya tergantung kondisi perangkat Anda.",
    name7: "Apabila tidak ada simbol khusus, satuan harga adalah satuan mata uang setempat.",
    name8: "Maaf! Info harga tidak tersedia di wilayah saat ini.",
    name11:"Biaya Tenaga Kerja",
    name12:"Harga Total",
    name13: "5. Jika biaya tenaga kerja \"/\", berarti biaya tenaga kerja perlu dikonsultasikan dengan toko.",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Camera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Tidak ada data",
    name2: "Penyedia Layanan:",
    name3: "Merek Layanan:",
    name4: "Telepon:",
    name5: "Jumlah Pesanan:",
    name6: "Nilai Layanan",
    name7: "Lingkungan Layanan:",
    name8: "Sikap Layanan:",
    name9: "Efisiensi Layanan:",
    name10: "Kualitas Layanan:",
    name11: "Evaluasi Pelanggan",
    name12:"hingga",
    name13:"Tutup",
    name14:"Alamat:"
  },
  reserSuccess: {
    name1: "Ambil foto layar info reservasi dan simpan sebagai tanda terima untuk mengakses layanan prioritas.",
    name2: "Berhasil dikirimkan",
    name3: "1. Bersihkan data",
    name4: "Cadangkan data pribadi yang penting di ponsel Anda terlebih dahulu",
    name5: "2. Nonaktifkan kata sandi penyalaan",
    name6: "Sebelum pergi ke toko layanan, harap:",
    name7: "Toko Layanan:",
    name8: "Waktu Pemesanan:",
    name9: "Keterangan Kerusakan:",
    name10: "Model Perangkat:",
    name11: "Nomor Pesanan:",
    name12: "Informasi Pemesanan",
  },
  title: {
    name1: "Mendukung negara berikut:",
    name2: "Pilih Model",
    name3: "Reservasi",
    name4: "Detail Toko Layanan",
    name5: "Pilih Toko Layanan",
  },
  error: {
    name1: "Tidak ada data. Periksa info perbaikan Anda",
    name2: "Perlu bantuan lainnya? Harap hubungi kami.",
    name3: "Maaf, tidak ada pusat Carlcare di wilayah Anda saat ini.",
    name4: "Pilih pusat layanan terlebih dahulu",
    name5: "Gagal",
    name6: "Pilih model perangkat terlebih dahulu",
    name7: "Informasi Kesalahan:",
    name8: "Jelaskan kebutuhan Anda secara terperinci",
  },
  add1:{
    "name0": "id",
    "name00": "Pilih Kotamu",//Choose your city
    "name01": "Jakarta",//Jakarta 这个城市
    "name0x": "Lainnya",//others
    "name1": "Pesanan Anda telah dikonfirmasi. Kami menunggu kedatangan Anda.",
    "name2": "Pilih Kota",
    "name3": "Silahkan masukan %1$s digit nomor telepon.",
    "name4": "Jam kerja",
    "name5": "Senin",
    "name6": "selasa",
    "name7": "rabu",
    "name8": "kamis",
    "name9": "jumat",
    "name10": "sabtu",
    "name11": "Minggu",
    "name12": "Masukan Negara dan cari"
  },
  add2:{
    "name0": "Indonesian",
    "name1": "Metode Perbaikan",
    "name2": "Perbaikan di tempat",
    "name3": "Jasa Pengiriman",
    "name4": "Tipe Kerusakan",
    "name5": "Ketuk untuk memilih tipe kerusakan",
    "name6": "Waktu Pemesanan:",
    "name7": "ketuk untuk memilih waktu pemesanan",
    "name8": "Alamat penjemputan",
    "name9": "Mohon memasukan nomor rumah/ jalan/kabupaten/provinsi",
    "name10": "Mohon memasukan kode pos",
    "name11": "Tambahkan alamat pengembalian",
    "name12": "Alamat pengembalian",
    "name13": "Lain-lain",
    "name14":"Harap ceritakan masalah perangkatmu secara rinci",
    "name15":"Mengirimkan Kode Pos",
    "name16":"Harap isi nomor/jalan/kecamatan/provinsi",
    "name17":"Harap isi kode pengembalian",
    "name18":"Kode pos pengembalian",
    "name19":"Alamat pengirim",
    "name20":"Pilih Provinsi",
    "name21":"Mohon izinkan Carlcare untuk mengetahui lokasi Anda",
    "name22":"gagal mendapatkan lokasi coba lagi pls"
  },
  add3:{
    "name0": "Indonesian",
    "name1": "Kurir kami akan segera menghubungi",
    "name2": "Halaman Utama",
    "name3": "Rincian Pengiriman",
    "name4": "Salin",
    "name5": "Salin Nomer Resi",
    "name6": "Informasi Penerima",
    "name7": "Nama",
    "name8": "Nomer Telepon",
    "name9": "Alamat",
    "name10": "Masukan nomer pesanan anda/nomer telepon untuk melihat detail pengiriman",
    "name11": "Tampilkan hanya 30 hari pesanan",
    "name12": "Nomer pesanan",
    "name13": "Tanggal Buat",
    "name14": "Pengitiman di kembalikan",
    "name15": "Informasi pengiriman",
    "name16": "Kirim",
    "name17": "Mengembalikan gawai ke pelanggan",
    "name18": "kembali",
    "name19": "batal kirim",
    "name20": "batalkan pengiriman",
    "name21": "pesanan tidak dapat di batalkan ketika belum di ambil kurir",
    "name23": "Tinjauan",
    "name24": "Perangkat telah terkirim",
    "name25": "Perangkat telah dikirim",
    "name26": "Diperbaiki",
    "name27": "Dalam Perbaikan",
    "name28": "Terkirim, toko telah menerima perangkat",
    "name29": "Menunggu penjemputan",
    "name30": "Mengajukan aplikasi penjemputan",
    "name31": "nomor pengiriman:",
    "name32": "Anda membatalkan pesanan",
    "name33": "Kurir membatalkan pesanan",
    "name33_1": "admin membatalkan pesanan",
    "name34": "Rincian pengiriman",
    "name35": "tolong masukkan kode verifikasi untuk membatalkan pesanan",
    "name36": "kirim kode",
    "name37": "kirim ulang",
    "name38": "kode",
    "name39": "tidak dapat diedit",
    "name41": "Mohon Pilih alasan pembatalan",
    "name42": "Informasi salah",
    "name43": "Masukan alasan",
    "name44": "Mohon masukan alasan",
    "name45": "Mengirim",
    "name46": "Dikarenakan jarak diluar jangkauan, mohon hubungi kami via WhatsApp, tim kami akan melayani Anda",
    "name47":"Layanan antar jemput Carlcare",
    "name48":"Akun Bisnis WhatsApp",
    "name49":"Toko membatalkan Pesanan",
    "name50":"Perintah telah dibatalkan",
    "name51":"JNE Express",
    "name52":"Receiver Info",
    "name53":"Arrived",
    "name54":"On delivery",
    "name55":"Picked",
    "name56":"Go to pick-up location",
    "name57":"Order accepted",
    "name58":"Pending",
  },
  reasonlist:{
    name0:"Merubah waktu penjemputan",
    name1:"Alamat tidak sesuai",
    name2:"Khawatir dengan proses layanan, ponsel hilang dan tidak ada kompensasi ",
    name3:"Ingin datang ke Service Center",
    name4:"Alasan privasi",
    name5:"Diluar jangkauan layanan antar jemput",
    name6:"Kurir tidak datang tepat waktu",
  },
  coupons: {
    name1:"Buka Aplikasi Carlcare untuk mendapatkan kupon",
    name2:"Tekan untuk membuka",
    name3:"Buka Aplikasi Carlcare untuk memberikan penilaian",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Pilih Layanan",
    name7:"Pembersihan Gratis",
    name8:"Upgrade Perangkat Lunak",
  },
  cancelorder:{
    "cancelReason0": "Info salah",
    "cancelReason1": "Tidak tiba tepat waktu",
    "cancelReason2": "Pesanan duplikat/bukan pesanan saya",
    "cancelReason3": "Kegagalan tidak terulang",
    "cancelReason4": "Cuma untuk tes/pertanyaan/acara/…",
    "cancelReason5": "Mahal",
    "cancelReason6": "Kekurangan material",
    "cancelReason7": "Tidak ada layanan yang istimewa",
    "cancelReason8": "Toko terlalu jauh",
    "cancelReason9": "Toko tutup",
    "cancelReason10": "Sikap pelayanan buruk",
    "cancelReason11": "Penggantian/perbaikan untuk merek lainnya",
    "cancelReason12": "Tidak dapat menemukan toko",
    "cancelReason13": "lainnya",
    "cancelOrder": "Batalkan pesanan",
    "reason_dialog_title": "Beri tahu kami alasan pembatalan",
    "Cancel": "Batal",
    "OK": "Oke",
    "name1": "Masukkan kode verifikasi",
    "name2": "Kode verifikasi tidak valid",
    "repair_reservation_detail_canceled": "Pesanan ini telah Dibatalkan!",
    "purchase_cancel_dialog_content": "Apakah Anda yakin ingin membatalkan pesanan?",
    "yes": "Ya",
    "no": "Tidak"
}
};